module.exports = __webpack_public_path__ + "img/p1.872c5d81.gif";